<span class="content"><ng-container *ngIf="deltaPercentage > 0">+</ng-container>{{ deltaPercentage * 100 | shortNumber }}%</span>
<i class="icon fs-16px" *ngIf="!!iconType" [uiType]="iconType" ui-icon uiTheme="fill"></i>
